import axios from "axios";

const fetchData = payload =>
  axios.post(`/api/v1/credentialing_dashboards/fetch_data`, payload);

const update = (npi_number, values) =>
  axios.put(`/api/v1/credentialing_dashboards/${npi_number}`, { values });

const fetchNPIRecords = npi =>
  axios.get(`/api/v1/credentialing_dashboards/${npi}`);

const credentialingDashboardApi = {
  fetchData,
  update,
  fetchNPIRecords,
};

export default credentialingDashboardApi;
